import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { DashboardState, PowerBIError, DashboardData } from '../types'

interface DashboardSliceState {
  dashboardState: DashboardState | null
  isLoading: boolean
  error: PowerBIError | null
  hasDashboard: boolean
  dashboards: DashboardData[]
  activeDashboardId: string | null
  isUploadModalOpen: boolean
  embedPosition: "docked" | "hidden",
  sessionId: string
}

const initialState: DashboardSliceState = {
  dashboardState: null,
  isLoading: true,
  error: null,
  hasDashboard: false,
  dashboards: [],
  activeDashboardId: null,
  isUploadModalOpen: false,
  embedPosition: "docked",
  sessionId: crypto.randomUUID(),
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setDashboardState: (state, action: PayloadAction<DashboardState | null>) => {
      state.dashboardState = action.payload
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setError: (state, action: PayloadAction<PowerBIError | null>) => {
      state.error = action.payload
    },
    setHasDashboard: (state, action: PayloadAction<boolean>) => {
      state.hasDashboard = action.payload
    },
    resetDashboard: (state) => {
      state.dashboardState = null
      state.isLoading = true
      state.error = null
      state.hasDashboard = false
    },
    setActiveDashboardId: (state, action: PayloadAction<string | null>) => {
      state.activeDashboardId = action.payload
    },
    toggleUploadModal: (state, action: PayloadAction<boolean>) => {
      state.isUploadModalOpen = action.payload
    },
    setEmbedPosition: (
      state,
      action: PayloadAction<"docked" | "hidden">
    ) => {
      state.embedPosition = action.payload
    },
  }
})

export const {
  setDashboardState,
  setLoading,
  setError,
  setHasDashboard,
  resetDashboard,
  setActiveDashboardId,
  toggleUploadModal,
  setEmbedPosition
} = dashboardSlice.actions

export default dashboardSlice.reducer 